{
  "version": 1,
  "asset_id": "f127591f-8bdc-4127-afae-88afbae7e25c",
  "project_id": "63ffb125-aed4-4f54-959a-0b116fa77b1d",
  "url": "/__l5e/assets-v1/f127591f-8bdc-4127-afae-88afbae7e25c/reflux-sleeve-after.webp",
  "r2_key": "a/v1/63ffb125-aed4-4f54-959a-0b116fa77b1d/f127591f-8bdc-4127-afae-88afbae7e25c/reflux-sleeve-after.webp",
  "original_filename": "reflux-sleeve-after.webp",
  "size": 31080,
  "content_type": "image/webp",
  "created_at": "2026-09-13T20:58:51Z"
}
